import { z } from "zod/v4";

import { PluginConfigType } from "../../../schemas/plugin";

export const GetSinglePreviewRequestPathParamSchema = z.object({
  experienceId: z.uuid(),
  organizationId: z.uuid(),
});

export type GetSinglePreviewRequestPathParamType = z.infer<
  typeof GetSinglePreviewRequestPathParamSchema
>;

export const GetSinglePreviewResponseBodySchema = z.any().nullable();
export type GetSinglePreviewResponseBodyType = PluginConfigType | null;
